export default {
    formId: "OtrosForm",
    formField: {
        //FIRST FORM
        name: {
            name: 'name',
            label: 'Nombre*',
            requiredErrorMsg: 'Por favor, ingrese su nombre'
        },
       lastName: {
            name: 'lastName',
            label: 'Apellido*',
            requiredErrorMsg: 'Por favor, ingrese su apellido'
        },
        email: {
            name: 'email',
            label: 'Email*',
            requiredErrorMsg: 'Por favor, ingrese su email'
        },
        phone: {
            name: 'phone',
            label: 'Celular*',
            requiredErrorMsg: 'Por favor, ingrese su celular'
        },
        codLocalidad: {
            name: 'codLocalidad',
            label: 'Código Postal*',
            requiredErrorMsg: 'Por favor, ingrese su código postal',
            invalidErrorMsg: 'Código postal inválido'
        },
        dni: {
            name: 'dni',
            label: 'DNI*',
            requiredErrorMsg: 'Por favor, ingrese su número de documento',
            invalidErrorMsg: 'DNI inválido'
        },
        //SECOND FORM
        tipoSeguro: {
            name: 'tipoSeguro',
        },
        idProducto: {
            name: 'idProducto',
            requiredErrorMsg: 'Por favor, seleccione una opción',
        },
        comentario: {
            name: 'comentario',
        },
        uploadedFile: {
            name: 'uploadedFile',
        },
    },
};
